import * as React from "react";
import { Portal } from "../../components/atoms/Portal";
import { MenuItem } from "../../interface";

class PopupMenu extends React.Component<{
    id?: string;
    onClose?: () => void;
    onClick?: (item: MenuItem) => void;
    title?: string;
    items: MenuItem[];
    menuWidth?: number;
}> {
    public render(): React.ReactElement {
        const { id, title, items, onClose, onClick, menuWidth } = this.props;
        return (
            <Portal>
                <div
                    className="popup_menu_bg"
                    style={{
                        width: menuWidth
                    }}
                >
                    <div className="menu_title" style={{ borderBottom: "1px solid gray" }}>
                        <abbr title={title}>{title}</abbr>
                    </div>
                    {items.map((item: MenuItem) => {
                        const key = typeof item === "string" ? item : item.key;
                        return (
                            <div
                                className={`menu_item ${item.color ? item.color : ""} ${item.key === "lock" ? "item_lock" : ""}`}
                                id={id ? `${id}-${key}` : undefined}
                                data-at_id={id ? `${id}_${key}` : undefined}
                                key={key}
                                onClick={() => {
                                    if (onClick) onClick(item);
                                }}
                            >
                                {(() => {
                                    if (item.icon) {
                                        return <item.icon />;
                                    }
                                    return "";
                                })()}
                                {item.icon && <span className="spacer"> </span>}
                                {typeof item === "string" ? item : item.name}
                            </div>
                        );
                    })}
                </div>
                <div className="popup_menu_blocker" onClick={onClose} />
            </Portal>
        );
    }
}
export { PopupMenu };
